(() => {
  angular
    .module('app.campaign')
    .controller('DeleteModalController', DeleteModal);

  DeleteModal.$inject = ['campaignCount', 'sourceFor', 'close'];

  function DeleteModal(campaignCount, sourceFor, close) {
    const vm = this;
    vm.sourceFor = sourceFor;
    vm.campaignCount = campaignCount;
    vm.confirmDelete = () => {
      close(true, 500);
    }
  }
})();
